// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"c4f5165c","605":"b52774d7","725":"2b858670"}[chunkId] + ".chunk.js";
};